import { ChangeDetectionStrategy, Component, input, output, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-button-link',
  templateUrl: './button-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class ButtonLinkComponent {
  private router = inject(Router);

  customCss = input<string>('');
  dataTest = input<string>('');
  label = input<string>('');
  ariaLabel = input<string>('');
  color = input<'orange' | 'blue' | 'dark-blue'>('dark-blue');
  url = input<string>();
  btnId = input<string>();
  isDisabled = input<boolean>(null);
  btnType = input<string>('button');
  route = input<string>();
  prependIconClass = input<string>();
  appendIconClass = input<string>();
  tabindex = input<string>();
  ariaHidden = input<boolean>();
  showSpinner = input<boolean>();
  clicked = output();

  onClick(): void {
    if (this.route()) {
      this.router.navigateByUrl(this.route());
    }

    if (this.url()) {
      window.open(this.url(), '_blank');
      return;
    }

    this.clicked.emit();
  }
}
